import { AlertCircle } from "lucide-react";

interface ErrorStateProps {
  title?: string;
  message?: string;
}

export function ErrorState({
  title = "Algo deu errado",
  message,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <AlertCircle className="size-10 text-red-400" />
      <p className="text-base font-medium text-neutral-800">{title}</p>
      {message && <p className="text-sm text-neutral-500">{message}</p>}
    </div>
  );
}
